import Marquee from "react-fast-marquee";
import { TECH_STACK } from "@/lib/site-data";

const Item = ({ label }) => (
  <span className="inline-flex items-center gap-8 md:gap-12 pr-8 md:pr-12">
    <span className="font-display font-700 text-5xl md:text-7xl lg:text-8xl tracking-tighter text-stroke hover:text-white transition-colors duration-300 whitespace-nowrap">
      {label}
    </span>
    <span className="h-2.5 w-2.5 rounded-full bg-cyan-400/70 shrink-0" />
  </span>
);

const TechMarquee = () => {
  return (
    <section
      id="stack"
      data-testid="stack-section"
      className="relative bg-[#0a0a0c] py-24 md:py-32 border-t border-white/10 overflow-hidden"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 mb-12">
        <span className="overline">// The Stack</span>
        <p className="mt-4 font-mono text-sm text-zinc-500 max-w-md">
          Languages, protocols and platforms shipped in production systems.
        </p>
      </div>

      <Marquee speed={45} gradient={false} autoFill className="py-2">
        {TECH_STACK.map((t, i) => (
          <Item key={i} label={t} />
        ))}
      </Marquee>
      <Marquee speed={35} direction="right" gradient={false} autoFill className="py-2 mt-4">
        {[...TECH_STACK].reverse().map((t, i) => (
          <Item key={i} label={t} />
        ))}
      </Marquee>
    </section>
  );
};

export default TechMarquee;
